import {
  Box,
  Container,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import CoInvestorAssuranceAudit from './components/report-sections/CoInvestorAssuranceAudit';
import CoInvestorAssuranceReportHeader from './components/report-headers/CoInvestorAssuranceReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';

function CoInvestorAssurance() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Co-Investor Assurance"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>NZTA is required to carry out investment audits of approved organisations to comply with Section 95(1)(e)(ii) of the Land Transport Management Act 2003.</Text>
              <Text mb={4}>Two types of audits are typically undertaken and two separate audit reports are produced. Normally, a technical audit is undertaken before the procedural audit. The Co-Investor Performance page shows the outcomes from the latest procedural and technical audits on the selected RCA.</Text>
              <Text mb={4}>If you choose a region, the page will show the outcomes for the RCAs in the region.</Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <CoInvestorAssuranceReportHeader />
          <CoInvestorAssuranceAudit />
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default CoInvestorAssurance;
